import * as Yup from "yup";
import {equipmentSchema} from "./equipmentSchema";
import {companySchema} from "./companySchema";

export const userSchema = Yup.object().shape({
  departmentUID: Yup.number(), // 부서 UID
  name: Yup.string().required("이름을 입력하세요"), // 이름
  email: Yup.string().email("이메일 형식에 맞지 않습니다.").required("이메일을 입력하세요"), // 이메일
  loginID: Yup.string(), // 로그인 ID
  loginPW: Yup.string(), // 로그인 비밀번호
  entryDate: Yup.date(), // 등록일
  expireDate: Yup.date(), // 만료일

  // note not used
  // uid: Yup.number(), // 고유값
  // guid: Yup.string(), // GUID
  // userLevel: Yup.number(), // 사용자 등급  0 - 없음, 1 - 최고 어드민,  2 - 협회 마스터, 3 - 업체 관리자, 4 - 업체 담당자
  // companyUID: Yup.number(), // 사업체 UID
  // extra: Yup.string(), // 기타

  // address: Yup.string(), // 주소
  // phone: Yup.string(), // 전화번호

  // modifyDate: Yup.string(), // 수정일
  // registerDate: Yup.string(), // 입사일

  // isDeleted: Yup.boolean(), // 삭제여부

  // // Non DB
  // token: Yup.string(), // 토큰
  // department: Yup.array().of(equipmentSchema),
  // company: Yup.array().of(companySchema),
});
